import moment from 'moment';
import 'moment/locale/pl';
import i18n from 'i18next';
// Import localeUtils to ensure the language change listener is configured
import './localeUtils';

/**
 * Capitalize first letter of a string.
 * @param {string} string The string to capitalize.
 * @returns {string} String with the first letter capitalized.
 */
const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Format date
 *
 * @param {string} date Date to be formatted
 * @param {string} format Desired date format
 * @returns {string} Formatted date
 */
export default (date, format = i18n.t('Common:localDateFormat', 'DD-MMM-YYYY')) => {
  // moment(undefined) returns the current date, so return the empty string instead
  if (!date) return '';

  // Moment locale is automatically updated by the language change listener
  return moment(date).format(format);
};
